/* (c) Copyright Frontify Ltd., all rights reserved. */

export const BOLD_PLUGIN = 'bold-plugin';
